import { Fragment } from "react";
import styled from "styled-components";
import Botao from "./components/Botao";
import logo from "./assets/logo-contare.png";
import secoes from "./apps";

const Container = styled.div`
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
    background-color: #181a1b;
    text-align: center;
    box-sizing: border-box;

    @media (max-width: 768px) {
        padding: 15px;
    }
`;

const Logo = styled.img`
    max-width: 300px;
    width: 100%;
    height: auto;
    margin-bottom: 20px;
`;

const Secao = styled.h2`
    font-weight: bold;
    color: white;
`
const SecaoTres = styled.h3`
    font-weight: bold;
    color: white;
`

const renderItens = (itens) =>
    itens.map((item) => <Botao key={item.link} texto={item.texto} link={item.link} tipo={item.tipo} />);

function App() {
    return (
        <Container>
            <Logo src={logo} alt="logo" />
            {secoes.map((secao) => (
                <Fragment key={secao.titulo}>
                    <Secao>{secao.titulo}</Secao>
                    {secao.itens && renderItens(secao.itens)}
                    {secao.subsecoes?.map((sub) => (
                        <Fragment key={sub.titulo}>
                            <SecaoTres>{sub.titulo}</SecaoTres>
                            {renderItens(sub.itens)}
                        </Fragment>
                    ))}
                </Fragment>
            ))}
        </Container>
    );
}

export default App;
